import React from 'react';
import classnames from 'classnames';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { valueFormat } from '@/pages/intelligence/utils/commonUtils';
import { getCountryFlag } from '@/pages/home/_config/countries';

import type { IBaseProps } from '@/pages/intelligence/types/common';

import AnnieImg from '@/pages/intelligence/assets/svg/dataSource/appnnie.svg';
import SensorImg from '@/pages/intelligence/assets/svg/dataSource/sensor-tower.svg';

interface IMetricsSourceProps extends IBaseProps {
  period: string;
  dataSource: string;
}

const MetricsSource: React.FC<IMetricsSourceProps> = (props) => {
  // period: 'day' | 'week' | 'month', dataSource: 'appannie' | 'sensortower',
  const { period, dataSource, className } = props;

  const { formatMessage } = useIntlExtend();

  const timeText: any = {
    day: 'dbi_compare_last_1_day',
    week: 'dbi_compare_last_1_week',
    month: 'dbi_compare_last_1_month',
    year: 'dbi_compare_last_12_month',
  };

  const dataSourceImg: any = {
    appannie: AnnieImg,
    sensortower: SensorImg,
  };

  return (
    <div className={className} key={period + dataSource}>
      <img
        src={dataSourceImg?.[dataSource]}
        className="dbi-metric-table__table-datasorce"
      />
      <span className="dbi-compare-mobile-text">
        {formatMessage({ id: timeText?.[period] })}
      </span>
    </div>
  );
};

interface ICountrieListProps extends IBaseProps {
  list: any[];
}

const CountrieList: React.FC<ICountrieListProps> = (props) => {
  const { list } = props;

  if (!Array.isArray(list)) {
    return <></>;
  }

  return (
    <>
      {list?.map((item) => (
        <div className="dbicoutrie-list--flex">
          <div className="dbi-coutrie-list__item">
            <img src={getCountryFlag(item?.market_abbr?.toLocaleUpperCase())} />
            <span>{item?.market}</span>
          </div>
          <div>{valueFormat(parseFloat(item.value))}</div>
        </div>
      ))}
    </>
  );
};

interface IMetricTableProps extends IBaseProps {
  MAXGAMENUM: number;
  showHeatMap: boolean;
  showCountries: boolean;
  list: any[];
}

const MetricTable: React.FC<IMetricTableProps> = (props) => {
  const { list, MAXGAMENUM, showHeatMap, showCountries } = props;

  if (!Array.isArray(list)) {
    return null;
  }

  return (
    <div className="dbi-flex-table dbi-metric-table">
      <div className=" dbi-table-first-colums dbi-table-first-colums">
        {list?.[0]?.metric_list?.map((item: any) => (
          <MetricsSource
            period={item?.period}
            dataSource={item?.source}
            className={classnames('dbi-metric-table__h3', {
              'dbi-table-list-item-countries': showCountries,
              'dbi-table-list-item': !showCountries,
            })}
          />
        ))}
      </div>

      {list?.map((item) => (
        <div
          className="dbi-flex-table__table-content dbi-metric-table__table-content"
          key={item?.game_id}
        >
          {showCountries
            ? item?.metric_list?.map((period: any) => (
                <div
                  key={period?.period + period?.metric}
                  className={classnames('dbi-table-list-item-countries', {
                    'dbi-table-list-item-heatmap':
                      showHeatMap &&
                      (list?.length === 1 || period?.isMax) &&
                      period?.value,
                  })}
                >
                  <div
                    className={classnames('dbi-table-list-item__text')}
                    style={{ lineHeight: period?.value ? '32px' : '115px' }}
                  >
                    {valueFormat(parseFloat(period?.value))}
                  </div>
                  {period?.countrys ? (
                    <div className="dbi-table-list-item__countries">
                      <CountrieList list={period?.countrys} />
                    </div>
                  ) : null}
                </div>
              ))
            : item?.metric_list?.map((period: any) => (
                <div
                  className={classnames('dbi-table-list-item', {
                    'dbi-table-list-item-heatmap':
                      showHeatMap &&
                      (list?.length === 1 || period?.isMax) &&
                      period?.value,
                  })}
                >
                  <div
                    key={period?.period + period?.metric}
                    className="dbi-table-list-item__text"
                  >
                    {valueFormat(parseFloat(period?.value))}
                  </div>
                </div>
              ))}
          {/* {item?.metric_list?.map((period: any) => (
            <div
              className={classnames({
                'dbi-table-list-item-countries': showCountries,
                'dbi-table-list-item': !showCountries,
              })}
            >
              <div
                key={period?.period + period?.metric}
                className={classnames('dbi-table-list-item__text', {
                  ' dbi-metric-table__h3': showCountries,
                  'dbi-table-list-item-heatmap': showHeatMap && (list?.length === 1 || period?.isMax) && period?.value,
                })}
              >
                {valueFormat(parseFloat(period?.value))}
              </div>
              {showCountries && (
                <div className="dbi-table-list-item__countries">
                  <CountrieList list={period?.countrys} />
                </div>
              )}
            </div>
          ))}*/}
        </div>
      ))}
      {/* {list?.length < MAXGAMENUM && (
        <div className="dbi-flex-table__table-content dbi-metric-table__table-content">
          {list?.[0]?.metric_list?.map((item: any, i: number) => (
            <div
              key={i}
              className={classnames({
                'dbi-table-list-item-countries':
                  showCountries,
                'dbi-table-list-item':
                  !showCountries,
              })}
            ></div>
          ))}
        </div>
      )} */}
    </div>
  );
};

export default MetricTable;
